<template lang="pug">
header.nav-bar-wrap(:class="{ 'nav-bar-wrap-opacity' : !hasScrollSome && isOpacity }")
  .nav-bar
    a.logo(href='/')
      img(src="https://static.loklok.video/img/loklok-白.png?imageMogr2/format/webp", alt="logo", height="32")
    .navigation-bar
      search-input
      a.navigation(v-for="item in navigation" :href='item.url' :class="{ 'navigation-active' : $route.path === item.url }") {{item.name}}
</template>

<script>
export default {
  name: 'nav-bar',
  data() {
    return {
      hasScrollSome: false,
      navigation: [
        // {
        //  name: '首页',
        //  url: '/',
        //  opacity: true,
        // },
        // {
        //  name: '视频',
        //  url: '/list',
        //  opacity: false,
        // },
        {
          name: '首页',
          url: '/',
          opacity: true
        },
        {
          name: '影视资讯',
          url: '/articles',
          opacity: false
        },
        {
          name: '全部电影',
          url: '/home',
          opacity: false
        },
        {
          name: '下载APP',
          url: '/download_nd',
          opacity: false
        }
      ]
    }
  },
  computed: {
    isOpacity() {
      let index = this.navigation.map((item) => item.url).indexOf(this.$route?.path)
      return index > -1 ? this.navigation[index].opacity : false
    }
  },
  methods: {
    goIndex() {
      widow.location.href = '/'
    },
    gotoUrl(item) {
      // if (item.url.indexOf('https') > -1) {
      //   alert('即将上线')
      //   return
      // }
      // if (item.url.indexOf('https') > -1) return window.open(item.url)
      if (item.url === this.$route.path) return
      window.open(item.url)
    },
    watchScroll() {
      if (this.$route.path !== '/') return
      document.querySelector('.nav-bar-wrap').style = 'position: fixed'

      document.addEventListener('scroll', () => {
        if (window.pageYOffset > 500 && this.hasScrollSome === true) return
        if (window.pageYOffset <= 500 && this.hasScrollSome === false) return
        this.hasScrollSome = !this.hasScrollSome
      })
    }
  },
  mounted() {
    this.watchScroll()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">

.nav-bar-wrap
  width: 100%
  position: sticky
  top: 0
  z-index: 1000
  box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.50)

.nav-bar
  height: 60px
  z-index: 100
  background-color: $backgroundColor2
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5)
  @include flex-between
  box-sizing: border-box
  padding: 0 100px
  position: sticky
  top: 0

  .navigation
    cursor: pointer
    color: #FEFEFE
    font-size: 18px
    margin-left: 60px
    padding-bottom: 7px
    position: relative

.navigation-bar
  @include flex-between
  flex: none
  transform: translateY(3.5px)

.logo
  cursor: pointer
  height: 32px
  flex: none
  img
    height: 100%

.navigation-active
  font-weight: bold

.navigation-active::after
  content: ' '
  width: 16px
  height: 3px
  border-radius: 2.5px
  background: $mainColor
  position: absolute
  bottom: 0
  left: 50%
  transform: translateX(-50%)

.nav-bar-wrap-opacity
  //height: 200px
  position: fixed
  top: 0
  width: 100%
  background-image: linear-gradient(180deg, #0F0F0F 0%, rgba(15, 15, 15, 0.00) 100%)
  box-shadow: none
  //background-image: linear-gradient(0deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.40) 100%)
  .nav-bar
    border-bottom: 0px solid #eee
    background-color: rgba(0, 0, 0, 0)
    box-shadow: none

a
  text-decoration: none

@media screen and (max-width: 1280px)
  .nav-bar
    padding: 0 10px
</style>
